import { BookingAddOnSelection, BookingAddOnSubmission } from './types';

/*
 * ⭐ THE ONE PLACE the submit payload is built. Keep it that way.
 *
 * RES-1051 records the owning party being dropped independently at every point along the round trip —
 * both read types, both payload constructors, the submit type, cart assembly, helix's DTO and the creation
 * path — because each of those enumerates fields separately, and any one was enough to lose it. RES-1185
 * extends this with the custom form's answers and RES-1057 with the vendor's questions, so a second
 * construction site is the failure this function exists to prevent.
 *
 * ⛔ snake_case throughout: helix applies a global `whitelist: true` that strips undeclared fields
 * SILENTLY, so a camelCase key loses its value with no error raised anywhere.
 */
export const buildAddOnSubmission = (selection: Array<BookingAddOnSelection>): Array<BookingAddOnSubmission> =>
  selection
    /* Quantity zero is not an order. Removing the last one removes the line rather than sending a nil. */
    .filter(item => item.quantity > 0)
    .map(item => ({
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      ...(item.currency ? { currency: item.currency } : {}),
      ...(item.description ? { description: item.description } : {}),
      ...(item.image_url ? { image_url: item.image_url } : {}),
      /*
       * Lower-cased. `catalog_company_uuid` collates case-insensitively in MySQL while JS string identity
       * does not, so an unnormalised value makes one company look like two.
       */
      ...(item.owning_party ? { owning_party: item.owning_party.toLowerCase() } : {}),
    }));
